import React, { useState } from "react";
import { Button, Form, Col, Row } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import cellEditFactory from "react-bootstrap-table2-editor";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderTitle,
} from "../../../_metronic/_partials/controls";
import { sortCaret, headerSortingClasses } from "../../../_metronic/_helpers";
import { useSelector, useDispatch } from "react-redux";
import { selectApproval, createApproval, selectLoading } from "./fssSlice";
import { useHistory } from "react-router-dom";
import {
  formatDate,
  sizePerPageList,
  showSuccessDialog,
  showErrorDialog,
  StatusFormatter,
  formatCurrency,
} from "../../utility";
import Select from "react-select";
import { LayoutSplashScreen } from "../../../_metronic/layout";

function useForceUpdate() {
  const [value, setValue] = useState(0); // integer state
  return () => setValue((value) => value + 1); // update the state to force render
}

export const FssApproval = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const forceUpdate = useForceUpdate();
  const loading = useSelector(selectLoading);

  const data = useSelector(selectApproval);

  // Add status field to prevent object is not extensible error
  const initData = data.map((item, index) => ({
    ...item,
    no: index + 1,
    status: null,
    remarkRow: "",
  }));

  const [tableData, setTableData] = useState(initData);
  const [remarkAll, setRemarkAll] = useState("");
  const [disabledStatus, setDisabledStatus] = useState(false);
  const [actionRejected, setActionRejected] = useState("");
  const [btnDisabled, setbtnDisabled] = useState(false);

  // Return if data null
  if (!tableData.length > 0) {
    history.push("/fss-asm-bm");
  }

  const handleSave = () => {
    // Validation
    let isValid = true;
    tableData.forEach((e) => {
      if (e.status === null) {
        isValid = false;
        return showErrorDialog("Please select approval material status first!");
      }

      if (e.status !== "A" && e.remarkRow === undefined) {
        isValid = false;
        return showErrorDialog("Please fill remark reject first!");
      }
    });
    if (!isValid) return;
    setbtnDisabled(true);

    // Setup Request Body Params
    const params = tableData.map((e) => {
      return {
        approvalDetailId: e.approvalDetailId,
        status: e.status,
        remark: e.remarkRow,
      };
    });
    console.log("params", params);
    callApi(params);
  };

  const handleApproveAll = () => {
    setDisabledStatus(true);
    // Setup Request Body Params
    const params = tableData.map((e) => {
      return {
        approvalDetailId: e.approvalDetailId,
        status: "A",
        remark: remarkAll,
      };
    });
    callApi(params);
  };

  const handleRejectAll = () => {
    // Validation
    if (remarkAll === "") {
      showErrorDialog("Please fill remark reject all first!");
      return;
    }
    setDisabledStatus(true);

    // Setup Request Body Params
    const params = tableData.map((e) => {
      return {
        approvalDetailId: e.approvalDetailId,
        status: "R",
        remark: remarkAll,
      };
    });
    callApi(params);
  };

  const callApi = async (params) => {
    try {
      const response = await dispatch(createApproval(params));
      // setDisabledStatus(false);
      // setbtnDisabled(false);
      console.log(response, "response");

      if (response.payload.status === 200) {
        const action = await showSuccessDialog("Data has been saved!");
        if (action.isConfirmed) history.push("/fss-asm-bm");
      } else {
        setDisabledStatus(false);
        setbtnDisabled(false);
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      console.log("error", error);
      setDisabledStatus(false);
      setbtnDisabled(false);
      showErrorDialog("Something went wrong!");
    }
  };

  const handleActionChange = async (e, row, rowIndex, formatExtraData) => {
    if (e === null) {
      formatExtraData[rowIndex].status = null;
    } else {
      formatExtraData[rowIndex].status = e.value;
    }

    let isValid = true;
    tableData.forEach((e) => {
      console.log(e.status, "test");
      if (e.status === null) {
        setDisabledStatus(false);
      } else setDisabledStatus(true);
    });
    if (!isValid) return;
    setTableData(formatExtraData);
    forceUpdate();
  };

  const rowClasses = (row, rowIndex) => {
    let classes = null;
    if (row.status === "R") {
      classes = "textarea-red-border";
    } else if (row.status === "A") {
      classes = "";
    }
    return classes;
  };
  const approvalFormatter = (cell, row, rowIndex, formatExtraData) => {
    return (
      <Select
        className="action-approve-reject"
        menuPortalTarget={document.body}
        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
        options={[
          { value: "A", label: "Approve" },
          { value: "R", label: "Reject" },
        ]}
        onChange={(e) => {
          handleActionChange(e, row, rowIndex, formatExtraData);
        }}
        isSearchable={false}
        isClearable={true}
        placeholder="Select"
      />
    );
  };

  const handleRemarkRowChange = (e, row, rowIndex, formatExtraData) => {
    formatExtraData[rowIndex].remarkRow = e.target.value;
    setTableData(formatExtraData);
  };

  const remarkFormatter = (cell, row, rowIndex, formatExtraData) => {
    return (
      <div>
        <Form.Control
          className={`remark-brqa ${
            row.status == "R" ? "textarea-red-border" : ""
          }`}
          as="textarea"
          placeholder="Leave a comment here"
          style={{ height: "80px" }}
          value={row.remarkRow}
          onChange={(e) =>
            handleRemarkRowChange(e, row, rowIndex, formatExtraData)
          }
          maxLength={255}
        />
      </div>
    );
  };

  const dateFormatter = (cell) => {
    return <span>{formatDate(cell)}</span>;
  };

  const columns = [
    {
      text: "No",
      dataField: "no",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      editable: false,
    },
    {
      text: "APL Return Number ",
      dataField: "retNumber",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      editable: false,
    },
    {
      text: "Invoice Ref Num",
      dataField: "invoiceNo",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      editable: false,
    },
    {
      text: "Reason",
      dataField: "reasonName",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      editable: false,
    },
    {
      text: "Cust Name",
      dataField: "customerName",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Created By",
      dataField: "userName",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      editable: false,
    },
    {
      text: "Doc Date",
      dataField: "docDate",
      formatter: dateFormatter,
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      editable: false,
    },
    {
      text: "Material",
      dataField: "materialCode",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      editable: false,
    },
    {
      text: "Material Desc",
      dataField: "materialName",
      editable: false,
    },
    {
      text: "Rayon Type",
      dataField: "rayonType",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      editable: false,
    },
    {
      text: "Batch",
      dataField: "batch",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      editable: false,
    },
    {
      text: "Uom",
      dataField: "uom",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      editable: false,
    },
    {
      text: "Return Uom",
      dataField: "returnUom",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      editable: false,
    },
    {
      text: "Qty",
      dataField: "qty",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      editable: false,
    },
    {
      text: "Net Sales",
      dataField: "netPrice",
      sort: true,
      formatter: formatCurrency,
      sortCaret: sortCaret,
      headerSortingClasses,
      editable: false,
    },
    {
      text: "Nra",
      dataField: "nra",
      sort: true,
      formatter: StatusFormatter,
      sortCaret: sortCaret,
      headerSortingClasses,
      editable: false,
    },
    {
      text: "Client Name",
      dataField: "clientName",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      editable: false,
    },
    {
      text: "Exp Date",
      dataField: "expiredDate",
      editable: false,
      formatter: dateFormatter,
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      editable: false,
    },
    {
      text: "Action Per Item ",
      dataField: "action",
      formatter: approvalFormatter,
      formatExtraData: tableData,
      headerStyle: () => {
        return { width: "10%" };
      },
      editable: false,
    },
    {
      text: "Remarks Return",
      dataField: "remark",
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Sales Remark",
      dataField: "remarkRow",
      formatter: remarkFormatter,
      formatExtraData: tableData,
      headerStyle: () => {
        return { width: "15%" };
      },
    },
  ];

  const options = {
    showTotal: true,
    totalSize: tableData.length,
    sizePerPageList: sizePerPageList,
  };

  return tableData.length > 0 ? (
    loading ? (
      <LayoutSplashScreen />
    ) : (
      <Card>
        <CardHeader title="Approval Decision FSS / ASM / BM Detail"></CardHeader>
        <CardBody>
          {/* Table */}
          <BootstrapTable
            wrapperClasses="table-responsive"
            classes="table table-head-custom table-vertical-center overflow-hidden"
            bootstrap4
            bordered={false}
            keyField="approvalDetailId"
            data={tableData}
            columns={columns}
            pagination={paginationFactory(options)}
            rowClasses={rowClasses}
            hover
            cellEdit={cellEditFactory({
              mode: "click",
              blurToSave: true,
              onStartEdit: (row, column, rowIndex, columnIndex) => {},
              beforeSaveCell: (oldValue, newValue, row, column) => {},
              afterSaveCell: (oldValue, newValue, row, column) => {
                // handleQtyChange(newValue, row, column, tableData);
              },
            })}
          />

          {/* Footer */}
          <CardHeaderTitle className="mt-5">Decision</CardHeaderTitle>
          <Form>
            <Form.Group as={Row}>
              <Form.Label column sm={3}>
                <b>Remark Approval (Valid for all)</b>
              </Form.Label>
              <Col sm={4}>
                <Form.Control
                  as="textarea"
                  placeholder="Leave a comment here"
                  style={{ height: "100px" }}
                  onChange={(e) => {
                    setRemarkAll(e.target.value);
                  }}
                  value={remarkAll}
                />
              </Col>
            </Form.Group>
          </Form>
          <Form>
            <Row>
              <Col md="6" sm="6" lg="8">
                <Button
                  variant="success"
                  className="mr-5"
                  disabled={btnDisabled}
                  onClick={handleSave}
                >
                  Save
                </Button>
                <Button
                  variant="secondary"
                  className="mr-5"
                  onClick={() => history.push("/fss-asm-bm")}
                >
                  Back
                </Button>
              </Col>
              <Col md="6" sm="6" lg="4">
                <Button
                  variant="success"
                  className="mr-5"
                  disabled={disabledStatus}
                  onClick={handleApproveAll}
                >
                  Approve All
                </Button>
                <Button
                  variant="danger"
                  className="mr-5"
                  disabled={disabledStatus}
                  onClick={handleRejectAll}
                >
                  Reject All
                </Button>
              </Col>
            </Row>
          </Form>
        </CardBody>
      </Card>
    )
  ) : null;
};
